import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allowChatSLB: null,
    searchRadii: [],
    activeOrders: null,
};

const consumerSlice = createSlice({
    name: 'business',
    initialState,
    reducers: {
        setAllowChatSLB(state, action) {
            state.allowChatSLB = action?.payload;
        },
        setSearchRadii(state, action) {
            state.searchRadii = action?.payload;
        },
        setActiveOrders(state, action) {
            state.activeOrders = action?.payload;
        },
    },
});

export const { setAllowChatSLB, setSearchRadii, setActiveOrders } = consumerSlice.actions;
export default consumerSlice.reducer;
